import React from "react"
import { Page, Text, View, Font, Document } from "@react-pdf/renderer"
import moment from "moment"
import font from "@src/assets/fonts/Roboto-Regular.ttf"
import boldFont from "@src/assets/fonts/Roboto-Bold.ttf"
import { getSportsConfig } from "../../../utility/constants/sportConfig"

// Register Font
Font.register({
	family: "Roboto",
	src: font,
})

// Register Font
Font.register({
	family: "Roboto-Bold",
	src: boldFont,
})

const NewPDF = ({ sport: parentSport, data: parentData, events: parentEvents }) => {
	const sport = parentSport ?? localStorage.getItem("sport")
	const {
		hasSockets,
		isIndividualSport,
		layout,
		doesntHaveTime,
		playerNumbers,
		formations,
	} = getSportsConfig(sport)
	const events = parentEvents ?? JSON.parse(localStorage.getItem("events") ?? "[]")

	const { competition, organisation, season, location, time, date, halftime } =
		parentData ?? JSON.parse(localStorage.getItem("gameDetails") ?? "{}")

	const homeTeam =
		(
			parentData?.homeTeam ??
			JSON.parse(localStorage.getItem("homeTeam") ?? "{}")
		).name ?? "-"
	const awayTeam =
		(
			parentData?.awayTeam ??
			JSON.parse(localStorage.getItem("awayTeam") ?? "{}")
		).name ?? "-"

	const getScore = () => {
		if (parentData) {
			return `${parentData?.result?.homeScore ?? 0} - ${
				parentData?.result?.awayScore ?? 0
			}`
		}
		return `${localStorage.getItem("score-homeTeam") ?? 0} - ${
			localStorage.getItem("score-awayTeam") ?? 0
		}`
	}

	const data = [
		{ name: "Natjecanje", value: competition?.name ?? competition },
		{ name: "Sustav", value: organisation?.name ?? organisation },
		{ name: "Lokacija", value: location?.name ?? location ?? "-" },
		{ name: "Sezona", value: season?.name ?? season },
		{ name: "Sport", value: sport },
		{
			name: "Vrijeme",
			value: time ?? moment(date).format("DD/MM/YYYY - HH:mm"),
		},

		{
			name: "Ekipe",
			value: `${homeTeam} - ${awayTeam}`,
		},
	]

	if (!doesntHaveTime) {
		data.push({
			name: "Postavljeno trajanje poluvremena",
			value: `${halftime ?? localStorage.getItem("halftime")} minuta`,
		})
		data.push({
			name: "Trajanje utakmice",
			value: localStorage.getItem("time")
				? moment(
						JSON.parse(localStorage.getItem("time")).timeElapsed
				  ).format("mm:ss")
				: "-",
		})
	}
	if (layout === "winLose") {
		data.push({
			name: "Pobjednik",
			value: parentData?.result?.winner ?? "ivo", // TODO: Use data
		})
	} else {
		data.push({
			name: "Rezultat",
			value: getScore(),
		})
	}

	const getPlayersRows = () => {
		const homePlayers =
			(
				parentData?.homeTeam ??
				JSON.parse(localStorage.getItem("homeTeam") ?? "{}")
			).players ?? []
		const awayPlayers =
			(
				parentData?.awayTeam ??
				JSON.parse(localStorage.getItem("awayTeam") ?? "{}")
			).players ?? []

		const length = Math.max(homePlayers.length, awayPlayers.length)
		const toReturn = []
		const nameStyle = playerNumbers ? mediumColStyle : bigColStyle

		for (let i = 0; i < length; i++) {
			toReturn.push(
				<View style={tableRowStyle} key={`players-${i}`}>
					<View style={nameStyle}>
						<Text style={tableCellStyle}>
							{homePlayers[i]?.name
								? `${homePlayers[i]?.name} ${homePlayers[i]?.surname}`
								: ""}
						</Text>
					</View>
					{playerNumbers && (
						<View style={tinyColStyle}>
							<Text style={tableCellStyle}>
								{homePlayers[i]?.tshirtNumber ?? ""}
							</Text>
						</View>
					)}
					{formations && (
						<View style={tinyColStyle}>
							<Text style={tableCellStyle}>
								{homePlayers[i]?.position ?? ""}
							</Text>
						</View>
					)}
					<View style={nameStyle}>
						<Text style={tableCellStyle}>
							{awayPlayers[i]?.name
								? `${awayPlayers[i]?.name} ${awayPlayers[i]?.surname}`
								: ""}
						</Text>
					</View>
					{playerNumbers && (
						<View style={tinyColStyle}>
							<Text style={tableCellStyle}>
								{awayPlayers[i]?.tshirtNumber ?? ""}
							</Text>
						</View>
					)}
					{formations && (
						<View style={tinyColStyle}>
							<Text style={tableCellStyle}>
								{awayPlayers[i]?.position ?? ""}
							</Text>
						</View>
					)}
				</View>
			)
		}

		return toReturn
	}

	return (
		<Document>
			<Page style={pageStyle} size="A4" orientation="portrait">
				<View style={sectionStyle}>
					<Text style={titleStyle}>Brzi pregled utakmice</Text>
				</View>
				{/* Other Table */}
				<View style={sectionStyle}>
					<Text style={subtitleStyle}>Detalji</Text>
					{data.map((row, index) => (
						<View style={tableRowStyle} key={`data-${index}`}>
							<View style={{ ...bigColStyle, ...headerStyle }}>
								<Text style={{ ...tableCellStyle }}>{row.name}</Text>
							</View>
							<View style={bigColStyle}>
								<Text style={tableCellStyle}>{row.value}</Text>
							</View>
						</View>
					))}
				</View>
				{/* Players Table */}
				<View style={sectionStyle}>
					<Text style={subtitleStyle}>Igrači</Text>
					{isIndividualSport ? (
						<View style={tableStyle}>
							<View style={tableRowStyle} fixed>
								<View style={{ ...bigColStyle, ...headerStyle }}>
									<Text
										style={{ ...tableCellStyle, ...boldStyle }}
									>
										{homeTeam}
									</Text>
								</View>
								<View style={{ ...bigColStyle, ...headerStyle }}>
									<Text
										style={{ ...tableCellStyle, ...boldStyle }}
									>
										{awayTeam}
									</Text>
								</View>
							</View>

							{getPlayersRows()}
						</View>
					) : (
						<View style={tableStyle}>
							<View style={tableRowStyle} fixed>
								<View style={{ ...bigColStyle, ...headerStyle }}>
									<Text
										style={{ ...tableCellStyle, ...boldStyle }}
									>
										{homeTeam}
									</Text>
								</View>
								<View style={{ ...bigColStyle, ...headerStyle }}>
									<Text
										style={{ ...tableCellStyle, ...boldStyle }}
									>
										{awayTeam}
									</Text>
								</View>
							</View>
							{playerNumbers && (
								<View style={tableRowStyle}>
									<View
										style={{ ...mediumColStyle, ...headerStyle }}
									>
										<Text style={tableCellStyle}>Ime</Text>
									</View>
									<View
										style={{
											...tinyColStyle,
											...headerStyle,
										}}
									>
										<Text style={tableCellStyle}>Broj</Text>
									</View>
									{formations && (
										<View
											style={{
												...tinyColStyle,
												...headerStyle,
											}}
										>
											<Text style={tableCellStyle}>
												Pozicija
											</Text>
										</View>
									)}
									<View
										style={{ ...mediumColStyle, ...headerStyle }}
									>
										<Text style={tableCellStyle}>Ime</Text>
									</View>
									<View
										style={{
											...tinyColStyle,
											...headerStyle,
										}}
									>
										<Text style={tableCellStyle}>Broj</Text>
									</View>
									{formations && (
										<View
											style={{
												...tinyColStyle,
												...headerStyle,
											}}
										>
											<Text style={tableCellStyle}>
												Pozicija
											</Text>
										</View>
									)}
								</View>
							)}
							{getPlayersRows()}
						</View>
					)}
				</View>
				{/* Event Table */}
				{hasSockets && (
					<View style={sectionStyle}>
						<Text style={subtitleStyle}>Eventi</Text>
						<View style={tableStyle}>
							<View style={tableRowStyle} fixed>
								{!doesntHaveTime && (
									<>
										<View
											style={{
												...tinyColStyle,
												...headerStyle,
											}}
										>
											<Text style={tableCellHeaderStyle}>
												Q
											</Text>
										</View>
										<View
											style={{
												...smallColStyle,
												...headerStyle,
											}}
										>
											<Text style={tableCellHeaderStyle}>
												Vrijeme
											</Text>
										</View>
									</>
								)}
								<View style={{ ...smallColStyle, ...headerStyle }}>
									<Text style={tableCellHeaderStyle}>Event</Text>
								</View>
								<View style={{ ...smallColStyle, ...headerStyle }}>
									<Text style={tableCellHeaderStyle}>Ekipe</Text>
								</View>
								<View style={{ ...mediumColStyle, ...headerStyle }}>
									<Text style={tableCellHeaderStyle}>Igrač</Text>
								</View>
								<View style={{ ...bigColStyle, ...headerStyle }}>
									<Text style={tableCellHeaderStyle}>
										Komentar
									</Text>
								</View>
							</View>
							{events.map((event, index) => (
								<View style={tableRowStyle} key={`row-${index}`}>
									{!doesntHaveTime && (
										<>
											<View style={tinyColStyle}>
												<Text style={tableCellStyle}>
													{event.quarter}
												</Text>
											</View>
											<View style={smallColStyle}>
												<Text style={tableCellStyle}>
													{event.time}
												</Text>
											</View>
										</>
									)}

									<View style={smallColStyle}>
										<Text style={tableCellStyle}>
											{event.event}
										</Text>
									</View>
									<View style={smallColStyle}>
										<Text style={tableCellStyle}>
											{event.team}
										</Text>
									</View>
									<View style={mediumColStyle}>
										<Text style={tableCellStyle}>
											{event.playerName}
										</Text>
									</View>
									<View style={bigColStyle}>
										<Text style={tableCellStyle}>
											{event.comment}
										</Text>
									</View>
								</View>
							))}
						</View>
					</View>
				)}
			</Page>
		</Document>
	)
}

export default NewPDF

// * Styles for the PDF
const sectionStyle = { display: "section", marginBottom: 16 }
const pageStyle = {
	paddingTop: 16,
	paddingHorizontal: 40,
	paddingBottom: 56,
	fontFamily: "Roboto",
}
const titleStyle = { textAlign: "center", fontSize: 24 }
const subtitleStyle = { textAlign: "subtitle", fontSize: 18, paddingLeft: 8 }
const boldStyle = { fontFamily: "Roboto-Bold" }

// * Table Styles
const tableStyle = { display: "table", width: "auto" }
const tableRowStyle = { flexDirection: "row" }
const headerStyle = { borderTopWidth: 1, backgroundColor: "#bdbdbd" }

// Cell Text
const tableCellStyle = { textAlign: "center", margin: 5, fontSize: 10 }
const tableCellHeaderStyle = {
	textAlign: "center",
	margin: 4,
	fontSize: 12,
	fontWeight: "bold",
}

// Column styles
const tinyColStyle = {
	width: "10%",
	borderStyle: "solid",
	borderColor: "#000",
	borderWidth: 1,
}

const smallColStyle = {
	width: "20%",
	borderStyle: "solid",
	borderColor: "#000",
	borderWidth: 1,
}

const mediumColStyle = {
	width: "30%",
	borderStyle: "solid",
	borderColor: "#000",
	borderWidth: 1,
}

const bigColStyle = {
	width: "50%",
	borderStyle: "solid",
	borderColor: "#000",
	borderWidth: 1,
}
